import { APP_PREFIX } from '../actionTypePrefixes';
import { addActionTypePrefix } from '../util/addActionTypePrefix';

export const SET_ACTIVE_INTERFACE = addActionTypePrefix(
   'SET_ACTIVE_INTERFACE',
   APP_PREFIX
);
export const setActiveInterface = (interfaceType) => ({
   type: SET_ACTIVE_INTERFACE,
   interfaceType,
});

export const CLEAR_ACTIVE_INTERFACE = addActionTypePrefix(
   'CLEAR_ACTIVE_INTERFACE',
   APP_PREFIX
);
export const clearActiveInterface = () => ({
   type: CLEAR_ACTIVE_INTERFACE,
});

export const SET_ACTIVE_EXERCISE = addActionTypePrefix(
   'SET_ACTIVE_EXERCISE',
   APP_PREFIX
);
export const setActiveExercise = (
   exerciseId,
   moduleId,
   levelSelect,
   nextConfig
) => ({
   type: SET_ACTIVE_EXERCISE,
   exerciseId,
   moduleId,
   levelSelect,
   nextConfig,
});

export const INIT_ACTIVE_EXERCISE = addActionTypePrefix(
   'INIT_ACTIVE_EXERCISE',
   APP_PREFIX
);
export const initActiveExercise = ({
   exerciseDocument,
   levelSelect,
   nextConfig,
}) => ({
   type: INIT_ACTIVE_EXERCISE,
   exerciseDocument,
   levelSelect,
   nextConfig,
});

export const CLEAR_ACTIVE_EXERCISE = addActionTypePrefix(
   'CLEAR_ACTIVE_EXERCISE',
   APP_PREFIX
);
export const clearActiveExercise = () => ({
   type: CLEAR_ACTIVE_EXERCISE,
});

export const SET_TUTORIAL = addActionTypePrefix('SET_TUTORIAL', APP_PREFIX);
export const setTutorial = ({
   inlineTutorial,
   tutorialId,
   exerciseId,
   moduleId,
   secure,
   courseId,
}) => ({
   type: SET_TUTORIAL,
   inlineTutorial,
   tutorialId,
   exerciseId,
   moduleId,
   secure,
   courseId,
});

export const INIT_TUTORIAL = addActionTypePrefix('INIT_TUTORIAL', APP_PREFIX);
export const initTutorial = ({
   inlineTutorial,
   tutorialId,
   exerciseId,
   moduleId,
   secure,
   courseId,
}) => ({
   type: INIT_TUTORIAL,
   inlineTutorial,
   tutorialId,
   exerciseId,
   moduleId,
   secure,
   courseId,
});

export const CLEAR_TUTORIAL = addActionTypePrefix('CLEAR_TUTORIAL', APP_PREFIX);
export const clearTutorial = () => ({
   type: CLEAR_TUTORIAL,
});

export const SET_COURSE = addActionTypePrefix('SET_COURSE', APP_PREFIX);
export const setCourse = (courseId) => ({
   type: SET_COURSE,
   courseId,
});

export const INIT_COURSE = addActionTypePrefix('INIT_COURSE', APP_PREFIX);
export const initCourse = (courseDocument) => ({
   type: INIT_COURSE,
   courseDocument,
});

export const CLEAR_COURSE = addActionTypePrefix('CLEAR_COURSE', APP_PREFIX);
export const clearCourse = () => ({
   type: CLEAR_COURSE,
});

export const FORCE_REDUCE = addActionTypePrefix('FORCE_REDUCE', APP_PREFIX);
export const forceReduce = () => ({
   type: FORCE_REDUCE,
});

export const SET_USER_DATA = addActionTypePrefix('SET_USER_DATA', APP_PREFIX);
export const setUserData = (userData) => ({
   type: SET_USER_DATA,
   userData,
});

export const INITIAL_SYNC_RESPONSE = addActionTypePrefix(
   'INITIAL_SYNC_RESPONSE',
   APP_PREFIX
);
export const initialSyncResponse = (success, responseData) => ({
   type: INITIAL_SYNC_RESPONSE,
   success,
   responseData,
});

export const UPDATE_SUBSCRIPTION = addActionTypePrefix(
   'UPDATE_SUBSCRIPTION',
   APP_PREFIX
);
export const updateSubscription = (token) => ({
   type: UPDATE_SUBSCRIPTION,
   token,
});

export const SET_ASSETS_PERMISSIONS_FROM_SESSION_STORAGE = addActionTypePrefix(
   'SET_ASSETS_PERMISSIONS_FROM_SESSION_STORAGE',
   APP_PREFIX
);
export const setAssetsPermissionsFromSessionStorage = () => ({
   type: SET_ASSETS_PERMISSIONS_FROM_SESSION_STORAGE,
});

export const SET_SELECTED_LOOP_KITS = addActionTypePrefix(
   'SET_SELECTED_LOOP_KITS',
   APP_PREFIX
);
export const setSelectedLoopKits = (selectedLoopKits) => ({
   type: SET_SELECTED_LOOP_KITS,
   selectedLoopKits,
});

export const LOAD_SELECTED_LOOP_KITS = addActionTypePrefix(
   'LOAD_SELECTED_LOOP_KITS',
   APP_PREFIX
);
export const loadSelectedLoopKits = () => ({
   type: LOAD_SELECTED_LOOP_KITS,
});
